import React from 'react';
import { successStories } from '../mock/successStories';

const SuccessStoriesSection = () => (
  <section id="casos" className="w-full py-12 md:py-24 lg:py-32 bg-gray-100 dark:bg-gray-900">
    <div className="container px-4 md:px-6">
      <div className="flex flex-col items-center justify-center space-y-4 text-center">
        <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-gray-900 dark:text-gray-100">
          Casos de Éxito
        </h2>
        <p className="max-w-[700px] text-gray-600 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed dark:text-gray-400">
          Descubre cómo hemos ayudado a nuestros clientes a superar desafíos y alcanzar sus objetivos en comercio exterior.
        </p>
      </div>
      <div className="mx-auto grid max-w-5xl items-start gap-8 py-12 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {successStories.map((story) => (
          <div key={story.id} className="grid gap-4 p-8 rounded-2xl border border-gray-200 bg-white shadow-2xl transition-all duration-300 hover:shadow-3xl hover:-translate-y-2 dark:border-gray-700 dark:bg-gray-800">
            <h3 className="text-2xl font-bold text-indigo-700 dark:text-teal-500">{story.client}</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">Industria: {story.industry}</p>
            <div className="space-y-2">
              <p className="font-semibold text-gray-900 dark:text-gray-100">Desafío:</p>
              <p className="text-gray-700 dark:text-gray-300">{story.challenge}</p>
            </div>
            <div className="space-y-2">
              <p className="font-semibold text-gray-900 dark:text-gray-100">Solución:</p>
              <p className="text-gray-700 dark:text-gray-300">{story.solution}</p>
            </div>
            <div className="space-y-2">
              <p className="font-semibold text-gray-900 dark:text-gray-100">Resultado:</p>
              <p className="text-gray-700 dark:text-gray-300">{story.result}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default SuccessStoriesSection;